import { render, staticRenderFns } from "./RecordTable.vue?vue&type=template&id=89898e56&"
import script from "./RecordTable.vue?vue&type=script&lang=js&"
export * from "./RecordTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports